module.exports = __webpack_public_path__ + "public/images/drawing.6c300f6a7aeb34ae8a18c82568fb0649.png";